import type { TAddToCart } from "~/types/cart";
import type { TCourseDone, TCourseProgress, TWatch, UnexoPushInput } from "~/types/unexo"

export default function useUnexo() {
  const { unexo: config, baseUrl } = useRuntimeConfig().public;
  const { $auth } = useNuxtApp();

  function initUnexo() {
    if (config.enable) {
      useCookie("novinProjectId", {
        maxAge: 60 * 60 * 24 * 365,
        default: () => config.token,
      });
    }
  }

  function push(ctx: UnexoPushInput): void {
    try {
      const payload = {
        ...ctx,
        ...( $auth.user?.ssoId ? { userId: $auth.user?.ssoId } : {}),
        properties: {
          ...ctx.properties,
          baseUrl,
        },
      }

      if (config.logger) {
        console.info(payload)
      }

      if (import.meta.client && (window as any).unexo && config.enable) {
        (window as any).unexo.event.send(payload);
      }
    } catch (e) {
      console.error("Error on sending unixo events", e);
    }
  }

  function addToCart(data: TAddToCart) {
    push({
      name: "addToBasket",
      properties: data,
    });
  }

  function registerOrder(data: any) {
    push({
      name: "registerOrder",
      properties: data,
    });
  }

  function purchase(data: any) {
    push({
      name: "purchaseCompelete",
      properties: data,
    });
  }

  function addCoupon(data: { title: string; code: string }) {
    push({
      name: "couponApplied",
      properties: data,
    });
  }

  function pageView(route: string) {
    push({
      name: "pageView",
      properties: {
        path: route,
        pageType: "Panel",
      },
    });
  }

  function watchComplete(data: TWatch) {
    push({
      name: "videoDone",
      properties: data,
    });
  }

  function watchProgress(data: TWatch) {
    push({
      name: "videoProgress",
      properties: data,
    });
  }

  function startWatch(data: TWatch) {
    push({
      name: "playVideo",
      properties: data,
    });
  }

  function courseProgress(data: TCourseProgress) {
    push({
      name: "courseProgress",
      properties: data,
    });
  }

  function courseDone(data: TCourseDone) {
    push({
      name: "courseDone",
      properties: data,
    });
  }

  function repeatWatch(data: TWatch) {
    push({
      name: "videoRewatch",
      properties: data,
    });
  }

  return {
    initUnexo,
    push,
    purchase,
    pageView,
    addToCart,
    addCoupon,
    startWatch,
    courseDone,
    repeatWatch,
    registerOrder,
    watchComplete,
    watchProgress,
    courseProgress,
  };
}
